package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.domain.repository.InspectionRepository

class UpdateProgressInspectionUseCase(
    private val inspectionRepository: InspectionRepository
) {
    suspend operator fun invoke(
        inspectionId: String,
        totalAnswer: Int,
        vesselName: String,
        lastUpdatedIso: String
    ): Result<Unit> {
        return inspectionRepository.updateProgress(
            inspectionId = inspectionId,
            totalAnswer = totalAnswer,
            lastUpdated = lastUpdatedIso,
            vesselName = vesselName
        )
    }
}
